import { render, staticRenderFns } from "./SiteFactorSync.vue?vue&type=template&id=64bca67c&"
import script from "./SiteFactorSync.vue?vue&type=script&lang=js&"
export * from "./SiteFactorSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports